export default __webpack_public_path__ + "static/media/getting-started-2.26b04ba1.png";